import React, { useEffect, useState } from "react";
import Nav from "./Nav";
import Main from "./Main";
import "../styles/style.css";
import layout from "../layout";
import { Link, NavLink, useParams } from "react-router-dom";
import { useMediaQuery } from "react-responsive";

const primaryNavigation = [
  { label: "Overview", to: "/", icon: "bi-grid-1x2" },
  { label: "Courses", to: "/courses", icon: "bi-journals" },
  { label: "Organizations", to: "/organizations", icon: "bi-buildings" },
  { label: "Enrollments", to: "/course-enrollments", icon: "bi-person-check" },
  { label: "Course payments", to: "/course-payments", icon: "bi-receipt-cutoff" },
  { label: "Schedule", to: "/schedule", icon: "bi-calendar-week" },
];

const legacyNavigation = [
  { label: "Users", to: "/Users", icon: "bi-people" },
  { label: "Classes", to: "/Classes", icon: "bi-easel2" },
  { label: "Notes", to: "/Notes", icon: "bi-music-note-list" },
  { label: "Category", to: "/Category", icon: "bi-collection" },
  { label: "Tags", to: "/Tags", icon: "bi-tags" },
  { label: "Raga", to: "/Raga", icon: "bi-mic" },
  { label: "Payments", to: "/Payments", icon: "bi-currency-rupee" },
  { label: "Note reviews", to: "/NoteReviews", icon: "bi-check2-square" },
];

const Home = ({ isLoggedIn, setIsLoggedIn, children }) => {
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });
  const { resource } = useParams();
  let resultant_layout = {};
  for (var i = 0; i < layout.length; i++) {
    if (layout[i].resource === resource) resultant_layout = layout[i];
  }
  const [toggle, setToggle] = useState(false);
  const [mobileToggle, setMobileToggle] = useState(false);
  const Toggle = () => {
    setToggle(!toggle);
  };
  const MobileToggle = () => {
    setMobileToggle(!mobileToggle);
  };
  useEffect(() => {
    setToggle(true);
  }, [isTabletOrMobile]);
  return (
    <div className="row">
      {toggle && <aside className="sidebar-column col-4 col-md-2">
        <div className="sidebar-shell">
          <NavLink to="/" className="sidebar-brand" end>
            <span className="sidebar-brand-mark"><i className="bi bi-music-note-beamed" /></span>
            <span><strong>Singtico</strong><small>Admin console</small></span>
          </NavLink>
          <div className="sidebar-section">
            <span className="sidebar-section-label">Operations</span>
            <nav className="sidebar-nav" aria-label="Operations navigation">
              {primaryNavigation.map((item) => <NavLink key={item.to} to={item.to} end={item.to !== "/"} className="sidebar-link"><i className={`bi ${item.icon}`} /><span>{item.label}</span></NavLink>)}
            </nav>
          </div>
          <div className="sidebar-section sidebar-section-legacy">
            <span className="sidebar-section-label">Data workspace</span>
            <nav className="sidebar-nav" aria-label="Data workspace navigation">
              {legacyNavigation.map((item) => <NavLink key={item.to} to={item.to} className="sidebar-link"><i className={`bi ${item.icon}`} /><span>{item.label}</span></NavLink>)}
            </nav>
          </div>
        </div>
      </aside>}
      <div className="col px-0">
        <div>
          <Nav
            Toggle={Toggle}
            MobileToggle={MobileToggle}
            isLoggedIn={isLoggedIn}
            setIsLoggedIn={setIsLoggedIn}
          />
          <br />
          {isLoggedIn ? (
            children || <Main resultant_layout={resultant_layout} isLoggedIn={isLoggedIn} />
          ) : (
            <div className="p-4">
              <p>Please log in to continue.</p>
              <Link className="btn btn-primary" to="/">Go to login</Link>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Home;
